package com.patronat.top.features.auth.presentation

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.core.utils.UiText
import com.patronat.top.dto.AuthFlow
import com.patronat.top.dto.AuthMethod // <-- ВИКОРИСТОВУЄМО ТВІЙ DTO
import com.patronat.top.dto.UserRole

data class AuthViewState(
    val isLoading: Boolean = false,

    val phone: String = "",
    val email: String = "",
    val firstName: String = "",
    val lastName: String = "",
    val role: UserRole = UserRole.CLIENT,

    val phoneError: UiText? = null,
    val emailError: UiText? = null,
    val firstNameError: UiText? = null,
    val lastNameError: UiText? = null,
    val errorMessage: UiText? = null,

    val flow: AuthFlow = AuthFlow.LOGIN,
    val step: AuthStep = AuthStep.LoginInput,

    val loginMethod: AuthMethod = AuthMethod.PHONE,

    val isOtpSent: Boolean = false,
    val otpCode: String = ""
) : ViewState

enum class AuthStep {
    LoginInput,
    LoginVerify,

    RegisterInput,
    RegisterVerifyPhone,
    RegisterVerifyEmail
}

sealed interface AuthEvent : ViewEvent {

    data class OnTabSelected(val flow: AuthFlow) : AuthEvent
    data object OnBackClicked : AuthEvent


    data class OnLoginMethodSelected(val method: AuthMethod) : AuthEvent
    data class OnAuthDataChanged(
        val phone: String? = null,
        val email: String? = null,
        val firstName: String? = null,
        val lastName: String? = null,
        val role: UserRole? = null
    ) : AuthEvent

    data object OnSubmitLogin : AuthEvent
    data object OnSubmitRegister : AuthEvent
    data class OnSubmitCode(val code: String) : AuthEvent
    data object OnResendCode : AuthEvent

    data object ClearError : AuthEvent
}

sealed interface AuthEffect : ViewSideEffect {
    data class NavigateToHome(val role: UserRole) : AuthEffect
    data class ShowToast(val message: UiText) : AuthEffect
}